

export class UserChangePasswordDto {
    userId!: string;
    password!: string;
    confirmPassword!: string;
}